import { render, staticRenderFns } from "./dates-form.vue?vue&type=template&id=e12d8962&"
import script from "./dates-form.vue?vue&type=script&lang=js&"
export * from "./dates-form.vue?vue&type=script&lang=js&"
import style0 from "./dates-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dates-form.vue"
export default component.exports